const uiConfig = require('./ui.config.json');

export const getUiConfig = name => uiConfig[name];
